import { render, staticRenderFns } from "./DocDialog.vue?vue&type=template&id=b0b4f8c8&"
import script from "./DocDialog.vue?vue&type=script&lang=js&"
export * from "./DocDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports